import { Routes } from "react-router";

import { PrivateRoutes } from "./privateRoutes";
import { PublicRoutes } from "./publicRoutes";

export const AppRoutes = () => (
  <Routes>
    {PublicRoutes}
    {PrivateRoutes}
  </Routes>
);
